import React, {
    useCallback,
} from 'react'
import {
    openChatwoot,
} from '@src/services/chatwoot'
import useFlowRouter from '@src/shared-components/FlowRouter/useFlowRouter'
import APP_FLOW_STEPS from '@src/constants/FlowSteps'

import ScanQRError from './components/ScanQRError'

function ScanQRErrorPage(): JSX.Element {
    const {
        goToStep,
    } = useFlowRouter()
    const handleBackClick = useCallback(() => {
        goToStep(APP_FLOW_STEPS.scanQR)
    }, [goToStep])

    const handleEnterManuallyClick = useCallback(() => {
        goToStep(APP_FLOW_STEPS.manual_Mac_Address)
    }, [goToStep])

    return (
        <ScanQRError
            onBackClick={handleBackClick}
            onEnterManuallyClick={handleEnterManuallyClick}
            onSupportClick={openChatwoot}
        />
    )
}

export default ScanQRErrorPage
